export function formatPhone(value: string): string {
  const trimmed = value.trim()
  const digitsOnly = trimmed.replace(/\D/g, '')
  const hasCountryCode = trimmed.startsWith('+')
  let nationalDigits: string | null = null
  if (digitsOnly.length === 10 && !hasCountryCode) {
    nationalDigits = digitsOnly
  } else if (digitsOnly.length === 11 && digitsOnly.startsWith('1')) {
    nationalDigits = digitsOnly.slice(1)
  }
  if (nationalDigits === null) return trimmed
  return `(${nationalDigits.slice(0, 3)}) ${nationalDigits.slice(3, 6)}-${nationalDigits.slice(6)}`
}
